import { tr, locale } from "./locales.js";
import Mustache from "mustache";

let tableCache = {} ;
let cacheQueue = {} ;
export function registerNeedToCache(tbl, col, appName, force){
    if(!appName){ appName = "" ; }
    const cacheKey = appName+"_"+tbl ;
    if(tableCache[cacheKey] && !force){
        if(!tableCache[cacheKey][col]){ 
            tableCache[cacheKey][col] = {} ;
            for(let rec of tableCache[cacheKey].records){
                tableCache[cacheKey][col][rec[col]] = rec ;
            }
        }
        return;
    }
    const queueKey = appName+"_"+tbl+"_"+col ;
    if(cacheQueue[queueKey]){ return ; }
    cacheQueue[queueKey] = {
        table: tbl,
        app: appName,
        col: col
    } ;
}

export function upgradeCache(){
    let tablesToFetch = Object.keys(cacheQueue) ;
    if(tablesToFetch.length === 0){
        return Promise.resolve() ;
    }
    let cacheCopy = JSON.parse(JSON.stringify(cacheQueue)) ;
    cacheQueue = {} ;

    const tables = [] ;
    for(let key of tablesToFetch){
        if(!tables.some(t=>t.app===cacheCopy[key].app && t.table===cacheCopy[key].table)){
            tables.push(cacheCopy[key]) ;
        }
    }

    const promises = [] ;
    for(let tbl of tables){
        const cacheKey = tbl.app+"_"+tbl.table ;
        promises.push(
            window.getRestApi(tbl.app).list(tbl.table).then((results)=>{
                tableCache[cacheKey] = {
                    records : results
                } ;
            })
        ) ;
    }
    return Promise.all(promises).then(()=>{
        for(let key of tablesToFetch){
            const queueItem = cacheCopy[key] ;
            const cacheKey = queueItem.app+"_"+queueItem.table ;
            if(!tableCache[cacheKey][queueItem.col]){ 
                tableCache[cacheKey][queueItem.col] = {} ;
                for(let rec of tableCache[cacheKey].records){
                    tableCache[cacheKey][queueItem.col][rec[queueItem.col]] = rec ;
                }
            }
        }
    }) ;
}

export function getFromCache(tbl, col, key, appName){
    if(!appName){ appName = "" ; }
    const cacheKey = appName+"_"+tbl ;
    if(!tableCache[cacheKey]){ return null ;}
    if(!tableCache[cacheKey][col]){ return null ;}
    return tableCache[cacheKey][col][key] ;
}

export function getUrlOfLink2One(schema, field){
    let labelColumns = field.references.searchedColumns||[] ;
    if(field.references.label.indexOf("{{") !== -1){
        const extractResult = field.references.label.match(/{{([^}]+)}}/g) ;
        if(extractResult){
            for(let r=0; r<extractResult.length; r++){
                const lab = extractResult[r].replace(/^{{/, "").replace(/}}$/, "") ;
                if(!labelColumns.includes(lab)){
                    labelColumns.push(lab) ;
                }
            }
        }
    }else{
        const lab = field.references.label.trim() ;
        if(!labelColumns.includes(lab)){
            labelColumns.push(lab) ;
        }
    }
    
    let urlResource = field.references.model ;

    if(!field.references.joins){
        field.references.joins = [] ;
    }

    for(let join of field.references.joins){
        const alias = join.alias || join.target ;
        urlResource += "/joinone/"+join.target+"/as/"+alias ;
    }

    const modelDef = schema.models.find(m => m.name === field.references.model) ;
    if(modelDef){
        for(let i=0; i<labelColumns.length; i++){
            const colDef = modelDef.columns.find(c => c.name === labelColumns[i]) ;
            if(colDef && colDef.references){
                const alias = colDef.name ;
                urlResource += "/joinone/"+colDef.references.model+"/as/"+alias ;
                field.references.joins.push({
                    alias: alias,
                    target: colDef.references.model
                }) ;
                if(colDef.references.label.includes("{{")){
                    if(field.references.label.includes("{{")){
                        field.references.label = field.references.label.replace("{{"+colDef.name+"}}", 
                            colDef.references.label.replace(/\{\{/g, "{{"+alias+".")) ;
                    }else{
                        field.references.label = field.references.label.replace(colDef.name, 
                            colDef.references.label.replace(/\{\{/g, "{{"+alias+".")) ;
                    }
                }else{
                    field.references.label = field.references.label.replace(colDef.name, 
                        alias+"."+colDef.references.label) ;
                }
            }
        }
    }

    return urlResource;
}

export function getFromCacheOrFetch(tbl, col, key, appName){
    if(!appName){ appName = "" ; }
    const cacheKey = appName+"_"+tbl ;
    if(tableCache[cacheKey] && tableCache[cacheKey][col] && tableCache[cacheKey][col][key]){
        return Promise.resolve(tableCache[cacheKey][col][key]) ;
    }
    return window.getRestApi(appName).search(tbl, { where: col+" gte "+key, orderBy: col, limit: 100, deepLevel: 0}).then((results)=>{
        tableCache[cacheKey] = {
            records : results
        } ;
        tableCache[cacheKey][col] = {} ;
        for(let rec of results){
            tableCache[cacheKey][col][rec[col]] = rec ;
        }
        return tableCache[cacheKey][col][key] ;
    }) ;
}

export function formatColumnValue(colDef, value, appName, rowHeight=40){
    if(!colDef){ return value ;}
    if(colDef.values){
        if(Array.isArray(colDef.values)){
            const trKey = "values." + colDef.tableName + "." + colDef.name + "." + value ;
            const valTranslated = tr(trKey) ;
            if(valTranslated !== trKey){
                return valTranslated;
            }else{
                return value;
            }
        }else if(colDef.values){
            return colDef.values[value]||value ;
        }
        return value;
    }else if(colDef.type === "media") {
        return formatValue(value, colDef.type, rowHeight, colDef.size) ;
    }else if(colDef.references){
        let obj = getFromCache(colDef.references.model, colDef.references.column, value, appName) ;
        if(!obj){ return "" ;}
        let rendered = obj[colDef.references.label] ;
        if(colDef.references.label.indexOf("{{") !== -1){
            Mustache.parse(colDef.references.label);
            rendered = Mustache.render(colDef.references.label, obj); 
        }
        return rendered ;
    }
    return formatValue(value, colDef.type, rowHeight, colDef.size) ;
}

export async function formatColumnValueAsync(colDef, value, appName, rowHeight=40){
    if(!colDef){ return value ;}
    if(value === null || value === undefined) { return "" ;}
    if(colDef.values){
        if(!Array.isArray(value)){
            value = [value] ;
        }
        value = value.map(value=>{
            const trKey = "values." + colDef.tableName + "." + colDef.name + "." + value ;
            const valTranslated = tr(trKey) ;
            if(valTranslated !== trKey){
                return valTranslated;
            }
            if(Array.isArray(colDef.values)){
                return value;
            }else if(colDef.values){
                return colDef.values[value]||value ;
            }
        });
        return value.join(", ");
    }else if(colDef.type === "media") {
        return formatValue(value, colDef.type, rowHeight, colDef.size) ;
    }else if(colDef.references){
        let obj = await getFromCacheOrFetch(colDef.references.model, colDef.references.column, value, appName) ;
        if(!obj){ return "" ;}
        let rendered = obj[colDef.references.label] ;
        if(colDef.references.label.indexOf("{{") !== -1){
            Mustache.parse(colDef.references.label);
            rendered = Mustache.render(colDef.references.label, obj); 
        }
        return rendered ;
    }
    return formatValue(value, colDef.type, rowHeight, colDef.size) ;
}

export function formatValue(value, type, rowHeight=40, size){
    if (value === null || value === undefined) {
        if(["int", "integer", "number", "percent", "percentint"].indexOf(type) !== -1){
            return "";
        }else if(["double", "float", "float8", "numeric"].indexOf(type) !== -1){
            return "";
        }else{
            return "";
        }
    }

    if(type === "color") {
        return `<span>${value}</span><div style="background-color:${value};width:20px;height:20px;display:inline-block;margin: 0;position: absolute;top:50%;-ms-transform: translateY(-50%);transform: translateY(-50%);left:90px" class="rounded-circle"></div>`;
    }

    if(type === "boolean"){
        if(value === true){
            return tr("global.yes") ;
        } else if(value === false){
            return tr("global.no") ;
        } else {
            return "" ;
        }
    }

    if(!type && value && typeof(value) === "string" && /^fa. fa/.test(value)){
        type = "icon" ;
    }

    if(type === "icon"){
        return `<i class="${value}"></i>`;
    }

    if(type === "password"){
        return "******";
    }

    if(type === "textarea"){
        return `<div style="white-space: pre;">${value}</div>`;
    }

    if(!type && value && value.__isBinary){
        type = value.type ;
    }

    if(type === "media"){
        if(value){
            if(value instanceof File){
                value.mimetype = value.type;
                value.url = window.URL.createObjectURL(value);
            }
            if(/^image/.test(value.mimetype)){
                return `<img src="${value.url}" style="max-width: 100%; max-height: ${rowHeight}px">` ;
            } else if(/^audio/.test(value.mimetype)){
                return `<audio controls="controls" preload="auto" style="width: 100%; max-height: 100%;">
                        <source  src="${value.url}" type="${value.mimetype}">
                        Your browser does not support the audio tag.
                    </audio>` ;
            } else if(/^video/.test(value.mimetype)){
                return `<video preload="auto" style="max-width: 100%; max-height: ${rowHeight}px; vertical-align: middle">
                        // <source  src="${value.url}" type="${value.mimetype}">
                        <source  src="${value.url}" type="${value.mimetype}">
                        Your browser does not support the video tag.
                    </video>` ;
            } else if(/^application\/pdf/.test(value.mimetype)){
                return "&#x1f5ce; "+value.filename ;
            } else {
                return value.filename ;
            }
        }else{
            return "" ;
        }
    }
    if(type === "binary"){
        if(value){
            return `<a href="${value.url}" target="_blank" class="btn btn-sm btn-outline-secondary">
                <i class="fas fa-file-download"></i></a>
                <span>${value.filename || value.name}</span>` ;
        }
    }

    if(typeof(value) === "string" && /^[0-3]{1}[0-9]{3}-[0-1]{1}[0-9]{1}-[0-3]{1}[0-9]{1}[T ]{0,1}[0-2]{1}[0-9]{1}:[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}.[0-9]{3}Z{0,1}$/.test(value)){
        //date format "2019-07-14T10:37:10.101Z"
        if(!type){
            if(/T00:00:00.000Z$/.test(value)){
                //just midnight, consider as date
                type = "date";
            }else{
                //has time, use as datetime
                type = "datetime";
            }
        }
        value = new Date(value) ;
    }
    if(/^[0-3]{1}[0-9]{3}-[0-1]{1}[0-9]{1}-[0-3]{1}[0-9]{1}$/.test(value)){
        //date format "2019-07-14"
        value = new Date(value) ;
    }
    if(value instanceof Date){
        if(type === "datetime" || type === "timestamp"){
            if(value.toLocaleDateString){
                return value.toLocaleDateString(locale.lang)+" "+value.toLocaleTimeString(locale.lang, { hour: '2-digit', minute: '2-digit' }) ;
            }else{
                return value.toDateString()+" "+value.toTimeString() ; //IE10...
            }
        }else{
            var strValue = "";
            if(value.toLocaleDateString){
                strValue = value.toLocaleDateString(locale.lang) ;
            }else{
                strValue = value.toDateString() ; //old IE
            }
            if(type === "dateShort"){
                strValue = strValue.replace(value.getFullYear(), value.getYear()-100) ;
            }
            return strValue ;
        }
    }

    if(typeof(value)==="string" && 
        ["int", "integer", "number", "double", "float", "numeric"].indexOf(type) !== -1){
        value = Number(value) ;
    }
    
    if(typeof(value)==="object" && value.toNumber){
        value = value.toNumber() ;
    }
    if(typeof(value)==="number"){
        if(["int", "integer", "number", "percentint"].indexOf(type) !== -1){
            if(type === "percentint"){
                value = value*100 ;
            }
            let sign = value<0?-1:1 ;
            let n =  (Math.round(Math.abs(value))*sign).toFixed(0).replace(/,/g, locale.number.delimiters.thousands);
            n = n.replace(/\B(?=(\d{3})+(?!\d))/g, locale.number.delimiters.thousands) ;
            if(type === "percentint"){
                return n+" %" ;
            }
            return n;
        }else if(["double", "float", "float8", "numeric", "percent"].indexOf(type) !== -1){
            if(type === "percent"){
                value = value*100 ;
            }
            if(!size){ size = 2 ;}
            value = Number((Math.round(value*Math.pow(10,size))/Math.pow(10,size))) ;
            let n = value.toFixed(size);
            n = n.substring(0, n.length-(size+1)).replace(/\B(?=(\d{3})+(?!\d))/g, locale.number.delimiters.thousands)+ 
                locale.number.delimiters.decimal+
                n.substring(n.length-(size)) ;

            if(type === "percent"){
                return n+" %" ;
            }
            return n;
        }else{
            return ""+value;
        }
    }
    if(typeof(value)==="boolean"){
        return `<div class="d-flex form-control-lg justify-content-center"><input class="form-check-input" type="checkbox" ${value? 'checked' : 'unchecked'} style="pointer-events:none;" disabled></div>`;
    }
    if(type === "email" && value){
        return '<a href="mailto:'+value+'">'+value+'</a>' ;
    }
    return ""+value;
}